const t0 = Date.now();

export function createLogger(scope) {
  return (event, data = {}) => {
    const entry = {
      ts: new Date().toISOString(),
      elapsed: `${((Date.now() - t0) / 1000).toFixed(2)}s`,
      scope,
      event,
      ...data,
    };
    console.log(`[toonah:${scope}] ${event}`, entry);
    return entry;
  };
}
